module.exports = [{
      plugin: require('/opt/build/repo/dunk-test/node_modules/gatsby-plugin-modal-routing/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/dunk-test/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
